import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/services/query-keys';
import { tradesService } from '@/services/trades/trades-service';

const CUSTODIAN_PARAMS = { is_active: true } as const;

interface UseCustodiansOptions {
  /** Skip fetching until true — lets the always-mounted trade modal defer the
   *  load until it actually opens instead of firing on every page. */
  enabled?: boolean;
}

/**
 * Get the full active custodian list — the trade form needs every active custodian
 * for venue-default derivation and settlement-place selects.
 */
export const useCustodians = ({ enabled = true }: UseCustodiansOptions = {}) => {
  return useQuery({
    queryKey: queryKeys.trades.custodians(CUSTODIAN_PARAMS),
    queryFn: () => tradesService.getAllCustodians(CUSTODIAN_PARAMS),
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled,
  });
};
